import React from 'react';
import { Link } from 'gatsby';

interface DeployOwnModelCTAProps {
    className?: string;
}

export const DeployOwnModelCTA = ({ className = "" }: DeployOwnModelCTAProps) => {
    return (
        <div className={`border-t border-gray-100 px-4 py-6 ${className}`}>
            <div className="text-sm text-gray-600 mb-3 text-center">
                Don't see the model you need?
            </div>
            <div className="text-center">
                <Link
                    to="https://docs.predibase.com/inference/models/language-models#custom-base-models"
                    target="_blank"
                    className="text-sm text-orange hover:text-orange-600 font-medium transition-colors"
                >
                    Deploy your own model
                </Link>
            </div>
        </div>
    );
}; 